import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MappingService } from 'src/app/services/mapping.service';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { ISlider } from 'src/app/interfaces/book-store';

@Component({
  selector: 'app-slide-form',
  templateUrl: './slide-form.component.html',
  styleUrls: ['./slide-form.component.scss']
})
export class SlideFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('coverFile', {static:false}) coverFile: ElementRef;

  ITEM_KEY: any;
  ITEM: ISlider;
  TITLE: any = "Add new slide"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;
  GENRES_LIST: any[] = [];

  START_UPLOAD: boolean = false;
  uploadPercentCover: Observable<number>;
  SELECTED_COVER_FILE: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: BookstoreStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
      description: [null, Validators.required],
      genres: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
    })
    this.GENRES_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_GENRES, "name");
    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData(COLLECTION_NAME.BOOK_STORE_SLIDES, this.ITEM_KEY, (doc: ISlider) => {
          if (doc) {
            this.TITLE = "Edit slide"
            this.ITEM = doc;
            const { name, description } = doc;
            this.form.patchValue({
              name, description,
              genres: this.GENRES_LIST.filter(m => m.key === this.ITEM.genresKey)[0]
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/book-store/slides`])
          }
        })
      }
      else {
        this.form.patchValue({
          genres: this.GENRES_LIST[0]
        })
        this.ITEM = null;
        this.ITEM_KEY = null;
      }
    })
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  async uploadFileCover(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_COVER_FILE = event.target.files[0];
      if (this.ITEM) {
        if (this.SELECTED_COVER_FILE) {
          this.START_UPLOAD = true;
          const file: any = this.SELECTED_COVER_FILE;
          const soundPath = `app_center/${this.ITEM.key}/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercentCover = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          this.ITEM.coverFileDetail = files;
          this.START_UPLOAD = false;
        }
        this.store.updateCoverDownload(COLLECTION_NAME.BOOK_STORE_SLIDES, this.ITEM, this.ITEM.coverFileDetail, (success, res) => {
          this.snackBar.open("Cover has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.SELECTED_COVER_FILE = null
          this.coverFile.nativeElement.value = "";
        })
      }
    }

  }


  async onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      if (!this.SELECTED_COVER_FILE && !this.ITEM) {
        alert('Please select cover file');
        return;
      }
      this.form.disable();
      const { name, description, genres } = f;
      const { user } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const item: ISlider = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: null,
        organizationKey: null,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        coverFileDetail: this.ITEM ? this.ITEM.coverFileDetail : null,
        genresKey: genres.key,
        genresRef: this.ds.genresRef().doc(genres.key).ref,
      }

      if (this.SELECTED_COVER_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_COVER_FILE;
        const soundPath = `app_center/${item.key}/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercentCover = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.coverFileDetail = files;
        this.START_UPLOAD = false;
      }
      this.store.addItem(COLLECTION_NAME.BOOK_STORE_SLIDES, item, (success, res) => {
        if (success) {
          this.snackBar.open("Slide has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        this.coverFile.nativeElement.value = "";
        this.SELECTED_COVER_FILE = null;
        if (this.ITEM_KEY) {
          this.router.navigate([`/book-store/slides`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate([`/book-store/slides`])
  }

  newBook() {
    this.router.navigate([`/book-store/slides/slide-form/draft`])
  }
}
